<main animate.enter="ds-fade-enter" animate.leave="ds-fade-leave">
    <div dsTextOverflow
        class="text-container">
        <ds-slide-text [slide]="slide()"
            [controller]="controller()" />
    </div>
    <div class="media-container">
        <div id="media-wrapper">
            @if (content().showVideo) {
            <ds-video-player [videoId]="content().video.id"
                [controller]="controller()"
                [thumbnailUrl]="content().video.thumbnailImage"
                [fullscreen]="fullscreen()"
                [closedCaptions]="closedCaptions()"
                [autoplay]="!fullscreen()" />
            }
            @if (!content().showVideo && image()) {
            <img [src]="image()"
                onerror="this.src='assets/images/empty-placeholder.png'"
                alt="Video image" />
            }
        </div>
        <svg id="svg-waves"
            viewBox="0 0 949 1080"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd"
                clip-rule="evenodd"
                d="M438.749 1273.24C991.525 1311.89 1464.26 991.192 1494.62 556.944C1524.99 122.696 1101.49 -260.667 548.713 -299.321C-4.06289 -337.975 708.526 274.577 678.161 708.825C647.795 1143.07 -114.027 1234.58 438.749 1273.24Z"
                fill="var(--ds-color-wave, #fff)"
                fill-opacity="0.05" />
            <path fill-rule="evenodd"
                clip-rule="evenodd"
                d="M329.696 1333.18C893.939 1290.1 1323.91 895.842 1290.07 452.586C1256.22 9.32976 771.378 -315.075 207.135 -271.994C-357.107 -228.912 453.877 284.099 487.721 727.355C521.565 1170.61 -234.546 1376.27 329.696 1333.18Z"
                fill="var(--ds-color-wave, #fff)"
                fill-opacity="0.05" />
        </svg>
    </div>
</main>
